export const CONTACT_CENTER = {
  NUMBER: 800072072,
  MASK: 'Quiero llamar 800 072 072',
};
